exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hallmarkContainer {\n  margin-left: 10px;\n  margin-right: 10px;\n  margin-top: 0px;\n  margin-bottom: 0px; }\n\n.hallmarkContainer h1 {\n  margin-top: 10px; }\n\n.hallmarkContainer .page-header {\n  margin-top: 10px; }\n\n.hallmarkWordBreak {\n  -ms-word-break: break-all;\n  word-break: break-all;\n  word-break: break-word;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  hyphens: auto; }\n\n.descriptionText {\n  white-space: pre-wrap; }\n\ndiv.contentRight {\n  overflow: auto; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./app/components/docs-hallmarks/view/hallmarks.scss
 ** module id = 682
 ** module chunks = 0
 **/